import React, { useState } from "react";
import { useTheme, fonts } from "@/theme";
import { Icon } from "@/components/Icon";
import { Screen, TopBar } from "@/components/ui";
import { CRYSTAL_BASICS } from "@/data/crystalsData";

export default function Basics() {
  const { colors } = useTheme();
  const [openId, setOpenId] = useState(CRYSTAL_BASICS[0]?.id);

  return (
    <Screen>
      <TopBar title="Crystal Basics 🪨" />
      <div className="ritzy-fade" style={{ padding: "16px 20px 40px" }}>
        <div style={{ color: colors.muted, fontSize: 14, lineHeight: "20px", marginBottom: 16, fontFamily: fonts.text }}>
          The geology and terminology behind crystals — the stuff that helps you talk about them accurately.
        </div>
        {CRYSTAL_BASICS.map((b) => {
          const open = openId === b.id;
          return (
            <div key={b.id} style={{ background: colors.surfaceSecondary, border: `1px solid ${colors.border}`, borderRadius: 16, marginBottom: 12, overflow: "hidden" }}>
              <button data-testid={`basic-${b.id}`} className="pressable" onClick={() => setOpenId(open ? null : b.id)} style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, padding: 16, background: "transparent", border: "none", cursor: "pointer", textAlign: "left" }}>
                <div style={{ width: 42, height: 42, borderRadius: 12, background: colors.brandTertiary, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Icon name={b.icon} size={20} color={colors.onBrandTertiary} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ color: colors.onSurface, fontSize: 16, fontWeight: 700, fontFamily: fonts.text }}>{b.title}</div>
                  <div style={{ color: colors.muted, fontSize: 12, marginTop: 2, fontFamily: fonts.text }}>{b.intro}</div>
                </div>
                <Icon name={open ? "chevron-up" : "chevron-down"} size={20} color={colors.muted} />
              </button>
              {open ? (
                <div style={{ padding: "0 16px 16px" }}>
                  {b.sections.map((s, i) => (
                    <div key={i} style={{ marginTop: 10 }}>
                      <div style={{ color: colors.onSurface, fontSize: 14, fontWeight: 800, marginBottom: 3, fontFamily: fonts.text }}>{s.h}</div>
                      <div style={{ color: colors.onSurfaceSecondary, fontSize: 14, lineHeight: "21px", fontFamily: fonts.text }}>{s.p}</div>
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </Screen>
  );
}
